import { render, staticRenderFns } from "./PositionInfo.vue?vue&type=template&id=5238d22c&scoped=true&"
import script from "./PositionInfo.vue?vue&type=script&lang=js&"
export * from "./PositionInfo.vue?vue&type=script&lang=js&"
import style0 from "./PositionInfo.vue?vue&type=style&index=0&id=5238d22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5238d22c",
  null
  
)

export default component.exports